import React from 'react'

import './Button.css'

import Logo from '../../Images/behance_logo.png';


function ButtonBehance(props) {
  return (
    <>
  
        <button className="name noselect buttonsss"> {props.title} <img src={Logo} alt="" /></button>
       
  
    </>
  )
}


export default ButtonBehance